import { render, staticRenderFns } from "./participateTeams.vue?vue&type=template&id=961dc9ba&scoped=true&"
import script from "./participateTeams.vue?vue&type=script&lang=js&"
export * from "./participateTeams.vue?vue&type=script&lang=js&"
import style0 from "./participateTeams.vue?vue&type=style&index=0&id=961dc9ba&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "961dc9ba",
  null
  
)

export default component.exports